import axios from '../utils/axios';

export default function fetchCompanyDetails(adminId, jobId) {
    return (
        axios.get('/admin/' + adminId + '/job/' + jobId + '/company-details', {})
    )
}
